export const UtilityConstants = {
  RequestUtilityOverview: 'UTILITY_CONSTANTS.REQUEST_UTILITY_OVERVIEW',
  ReceiveUtilityOverview: 'UTILITY_CONSTANTS.RECEIVE_UTILITY_OVERVIEW',
  UpdateElectricalGraphDateRange: 'UTILITY_CONSTANTS.UPDATE_ELECTRICAL_GRAPH_DATE_RANGE',
  UpdateGasGraphDateRange: 'UTILITY_CONSTANTS.UPDATE_GAS_GRAPH_DATE_RANGE',
  SetUtilityError: 'UTILITY_CONSTANTS.SET_UTILITY_ERROR',
  UpdateWeatherAdjustedToggle: 'UTILITY_CONSTANTS.UPDATE_WEATHER_ADJUSTED_TOGGLE',
};

// ACTION Types
interface RequestUtilityOverviewAction {
  type: typeof UtilityConstants.RequestUtilityOverview;
  payload: undefined;
}

interface ReceiveUtilityOverviewAction {
  type: typeof UtilityConstants.ReceiveUtilityOverview;
  payload: UtilityOverview;
}

interface UpdateElectricalGraphDateRangeAction {
  type: typeof UtilityConstants.UpdateElectricalGraphDateRange;
  payload: GraphDateRange;
}

interface UpdateGasGraphDateRangeAction {
  type: typeof UtilityConstants.UpdateGasGraphDateRange;
  payload: GraphDateRange;
}

interface SetUtilityErrorAction {
  type: typeof UtilityConstants.SetUtilityError;
  payload: string;
}

export type UtilityActionTypes =
  | RequestUtilityOverviewAction
  | ReceiveUtilityOverviewAction
  | UpdateElectricalGraphDateRangeAction
  | UpdateGasGraphDateRangeAction
  | SetUtilityErrorAction;

// STATE slices
export interface UtilityOverview {
  interval: string;
  name: string;
  slug: string;
  unit: string;
  savings_data: SavingsDataType;
}

interface SavingsDataType {
  energy_usage: EnergyUsageType[];
  graph_data: GraphDataSet[];
  savings: SavingsType[];
}

interface EnergyUsageType {
  total: string;
  unit: string;
  type: string;
  name: string;
}

interface SavingsType {
  name: string;
  type: string;
}

interface GraphDataSet {
  x: string;
  actual: number;
  target: number;
  baseline: number;
}

export interface GraphDateRange {
  value: string;
  label: string;
  startDatetime?: string;
  endDatetime?: string;
}

export interface UtilityReducer {
  isFetching: boolean;
  utilityOverview?: UtilityOverview;
  electricalGraphDateRange: GraphDateRange;
  gasGraphDateRange: GraphDateRange;
  weatherAdjusted: boolean;
  error?: string;
}
